// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {RoomCapability, TrainingRoom, TrainingRoomGroupView, TrainingRoomType} from "@models";
import {SimMaterialDialogService, SimTrainingRoomService} from "@services";
import {Translations} from "@translations";
import {DialogData_DetailedRoomSelectionOutput} from "src/app/modules/dialog/material-dialogs/general-dialogs/detailed-room-selection-dialog/detailed-room-selection-dialog.component";
import {VMAutoCompleteGroup, VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-room-chip-input",
	templateUrl: "./sim-room-chip-input.component.html",
	styleUrls: ["./sim-room-chip-input.component.scss"],
	standalone: false,
})
export class SimRoomChipInputComponent implements OnInit {
	T = Translations;
	@Input() roomFc: FormArray<FormControl<TrainingRoom>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleRooms = false;

	@Input() trainingRoomType: TrainingRoomType = TrainingRoomType.Undefined;
	@Input() roomCapabilities: RoomCapability = RoomCapability.Undefined;
	@Input() occupiedRoomIds: string[] = [];

	optionSelected = output<TrainingRoom>();

	autoCompleteGroupedData: VMAutoCompleteGroup<TrainingRoom>[] = [];

	private _availableRooms: TrainingRoomGroupView[] = [];

	constructor(
		private _simTrainingRoomService: SimTrainingRoomService,
		private _simMaterialDialogService: SimMaterialDialogService,
	) {}

	reloadAutoCompleteData(searchString: string) {
		this.autoCompleteGroupedData = this._availableRooms
			.map((roomGroup) => {
				let rooms: VMAutoCompleteNormal<TrainingRoom>[] = roomGroup.trainingRooms
					.filter((room) => {
						return room.name.toLowerCase().includes(searchString.toLowerCase());
					})
					.map((room) => {
						return {value: room, displayName: room.name};
					});

				return {
					groupDisplayName: roomGroup.name,
					groupValues: rooms,
				};
			})
			.filter((group) => group.groupValues.length > 0);
	}

	openRoomSelectionDialog() {
		let tempRooms: TrainingRoom[] = this.roomFc.value;
		this._simMaterialDialogService
			.openDetailedTrainingRoomSelection(
				{
					preselectedTrainingRooms: tempRooms,
					singleRoom: !this.canSelectMultipleRooms,
				},
				{width: "1150px", height: "97vh"},
			)
			.then((data: DialogData_DetailedRoomSelectionOutput) => {
				if (data.trainingRoomSelection) {
					this.roomFc.clear();
					for (const trainingRoom of data.trainingRoomSelection) {
						this.roomFc.push(new FormControl(trainingRoom));
					}
				}
			});
	}

	ngOnInit(): void {
		this._simTrainingRoomService.getTrainingRoomsGroupedWithFilter(this.trainingRoomType, this.roomCapabilities).then((roomGroups) => {
			this._availableRooms = roomGroups;
			this.reloadAutoCompleteData("");
		});
	}
}
